import { grey } from "@mui/material/colors";
import Follow from "./Follow";
import { Divider } from "@mui/material";
import sp from "../../assets/images/Footer/sp.svg";
import you from "../../assets/images/Footer/you.svg";
import fb from "../../assets/images/Footer/fb.webp";
import tiktok from "../../assets/images/Footer/tiktok.svg";
import call from "../../assets/images/Footer/call.svg";
import sms from "../../assets/images/Footer/sms.svg";
import map from "../../assets/images/Footer/map.svg";
import appstore from "../../assets/images/Footer/appstore.webp";
import googlepl from "../../assets/images/Footer/googlepl.webp";
import mac from "../../assets/images/Footer/mac.webp";
import windows from "../../assets/images/Footer/windows.webp";
import arrow from "../../assets/images/Footer/arrow.webp";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="w-full relative">
      <Follow />
      <div className="w-full container mx-auto px-[20px]">
        <Divider sx={{ borderColor: grey }} />
      </div>
      <div className="w-full container mx-auto px-[20px]">
        <div className=" mx-auto grid grid-cols-1 md:flex-col lg:grid-cols-4 justify-center gap-8 items-start py-8">
          <div className=" w-full flex flex-col gap-3">
            <div className=" flex flex-row gap-1 items-center">
              <img src={sp} alt="sp" className="h-[31px]" />
              <p className="font-semibold text-[16px] text-[#053CC8] ">
                THÔNG TIN
              </p>
            </div>
            <div className="flex flex-col gap-2 w-full text-[16px]">
              <p>
                Hệ sinh thái chuyển đổi số toàn diện dành cho các đơn vị giáo
                dục, hỗ trợ số hóa, đơn giản quản trị, tối ưu vận hành, tiết
                kiệm chi phí tuyển sinh và tăng trải nghiệm học tập dành riêng
                cho các đơn vị giáo dục
              </p>
            </div>

            <div className=" w-full flex items-center gap-1 md:gap-4">
              <div>
                <Link
                  to="https://www.facebook.com/HeSinhThaiGiaoDucBlueRise"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={fb} alt="fb" />
                </Link>
              </div>
              <div className="w-9 h-9 border border-red-600 bg-red-600 flex items-center justify-center rounded-full">
                <Link
                  to="https://www.youtube.com/@BlueRiseVN"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={you} alt="you" />
                </Link>
              </div>
              <div className="w-9 h-9 border border-black bg-black flex items-center justify-center rounded-full">
                <Link
                  to="https://www.tiktok.com/@bluerise.vn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={tiktok} alt="tiktok" />
                </Link>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-3 w-full">
            <div className="h-[40px] flex items-center gap-1">
              <img src={sp} alt="sp" className="h-[31px]" />
              <p className="font-semibold text-[16px] text-[#053CC8]">
                LIÊN HỆ
              </p>
            </div>
            <div className="flex flex-row items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#E6ECFA]">
                <img src={call} alt="call" />
              </div>

              <p className="text-[16px]"> 0981 317 225</p>
            </div>
            <div className="flex flex-row items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#E6ECFA]">
                <img src={sms} alt="sms" />
              </div>
              <p className="text-[16px]">support@bluerise.com.vn</p>
            </div>
            <div className="flex flex-row items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#E6ECFA]">
                <img src={map} alt="map" />
              </div>
              <div className="w-full">
                <p className="text-[16px]">
                  BT16B6-32, Làng Việt Kiều Châu Âu, Phường Mộ Lao, Quận Hà
                  Đông, Thành phố Hà Nội.
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-3 w-full">
            <div className="h-[40px] flex items-center gap-1">
              <img src={sp} alt="sp" />
              <p className="font-semibold text-[16px] text-[#053CC8]">
                ĐƯỜNG DẪN
              </p>
            </div>
            <div className="flex flex-col gap-4">
              <div className="flex gap-2 items-center hover:text-blue-600 cursor-pointer">
                <img src={arrow} alt="sp" />
                <p className="text-[16px]">Trang chủ</p>
              </div>
              <div className="flex gap-2 items-center hover:text-blue-600 cursor-pointer">
                <img src={arrow} alt="sp" />
                <p className="text-[16px]">Giới thiệu</p>
              </div>
              <div className="flex gap-2 items-center hover:text-blue-600 cursor-pointer">
                <img src={arrow} alt="sp" />
                <p className="text-[16px]">Giải pháp</p>
              </div>
              <div className="flex gap-2 items-center hover:text-blue-600 cursor-pointer">
                <img src={arrow} alt="sp" />
                <p className="text-[16px]">Case Study</p>
              </div>
              <div className="flex gap-2 items-center hover:text-blue-600 cursor-pointer">
                <img src={arrow} alt="sp" />
                <p className="text-[16px]">Tin tức & sự kiện</p>
              </div>
              <div className="flex gap-2 items-center hover:text-blue-600 cursor-pointer">
                <img src={arrow} alt="sp" />
                <p className="text-[16px]">Liên hệ</p>
              </div>
              <div className="flex gap-2 items-center hover:text-blue-600 cursor-pointer">
                <a
                  className="flex items-center gap-2 "
                  href="https://doc.bluerise.com.vn"
                  target="_blank"
                >
                  <img src={arrow} alt="sp" />
                  <p className="text-[16px] text-[#000029] hover:text-blue-600 cursor-pointer">
                    Hướng dẫn sử dụng
                  </p>
                </a>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-3 w-full">
            <div className="h-[40px] flex gap-2 items-center">
              <img src={sp} alt="sp" />
              <p className="font-semibold text-[16px] text-[#053CC8]">
                TẢI XUỐNG
              </p>
            </div>
            <div className="flex flex-col md:items-start w-full items-center gap-2">
              <div className="w-full flex flex-row items-center">
                <div className="w-full">
                  <Link
                    to="https://play.google.com/store/apps/details?id=com.bluerisehs.app"
                    target="_blank"
                  >
                    <img
                      src={googlepl}
                      alt="googlePlay"
                      className="hover:cursor-pointer w-full hover:scale-105 transition-transform duration-200 ease-out"
                    />
                  </Link>
                </div>
                <div className="w-full">
                  <Link
                    to="https://apps.apple.com/vn/app/bluerisehs/id6759903432?l=vi"
                    target="_blank"
                  >
                    <img
                      src={appstore}
                      alt="appStore"
                      className="hover:cursor-pointer w-full hover:scale-105 transition-transform duration-200 ease-out"
                    />
                  </Link>
                </div>
              </div>
              <div className="w-full flex flex-row items-center">
                <div className="w-full">
                  <Link
                    to="https://dl-bundle.bluerise.com.vn/desktop/releases/bluerise_install_1.0.52_x64.exe"
                    target="_blank"
                  >
                    <img
                      src={windows}
                      alt="googlePlay"
                      className="hover:cursor-pointer w-full hover:scale-105 transition-transform duration-200 ease-out"
                    />
                  </Link>
                </div>
                <div className="w-full">
                  <Link
                    to="https://drive.google.com/uc?export=download&id=1HWysE9wQBIiXX2kAOdM31X6NSzKnf4ZH"
                    target="_blank"
                  >
                    <img
                      src={mac}
                      alt="appStore"
                      className="hover:cursor-pointer w-full hover:scale-105 transition-transform duration-200 ease-out"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full container mx-auto px-[20px]">
        <Divider sx={{ borderColor: grey }} />
      </div>
      <div className="w-full container mx-auto px-[20px] py-2">
        <div className=" w-full flex items-center justify-center">
          <div className=" w-full  flex flex-col gap-3 lg:flex-row lg:justify-between">
            <div className="flex flex-row items-center gap-4">
              <Link to="/chinh-sach">
                <p className="text-[16px] text-[#3D3D3D] font-medium hover:text-blue-500">
                  Chính sách bảo mật
                </p>
              </Link>
              <Link to="/dieu-khoan">
                <p className="text-[16px] text-[#3D3D3D] font-medium hover:text-blue-500">
                  Điều khoản
                </p>
              </Link>
            </div>
            <div>
              <p className="text-[16px] text-[#3D3D3D] font-medium">
                Copyright © 2024 BlueSkyIT. All Rights Reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
